import { Link, TableCell, TableRow } from "@mui/material"
import { JIRA_BROWSE_URL, toPercent } from "plugins/toolbox/constants"

export function DuplicateFinderRow({ item }) {
    const similarity = `${toPercent(item.similarity)}`

    return (
        <TableRow hover>
            <TableCell>
                <Link href={`${JIRA_BROWSE_URL}/${item.keyA}`} target="_blank" rel="noopener noreferrer">
                    {item.keyA}
                </Link>
            </TableCell>
            <TableCell>
                <Link href={`${JIRA_BROWSE_URL}/${item.keyB}`} target="_blank" rel="noopener noreferrer">
                    {item.keyB}
                </Link>
            </TableCell>
            <TableCell align="right">{similarity}</TableCell>
        </TableRow>
    )
}
